;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="53b30e0b-6f4d-4551-902d-1c00328b69a4",e._sentryDebugIdIdentifier="sentry-dbid-53b30e0b-6f4d-4551-902d-1c00328b69a4")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

const SECURITY_ICONS_ID = 'shop-header-security-icons-box';
const SHIPPING_FEE_TEXT_ID = 'shop-header-shipping-fee-text';
const BURGER_PANEL_PORTAL = 'burger-panel-portal-container';
const AUTH_READY = 'AUTH-READY-v1';
const AUTH_SUCCESS_EVENT = 'AUTH-SUCCESS-EVENT-v1';
const AUTH_FAILURE_EVENT = 'AUTH-FAILURE-EVENT-v1';
const AUTH_LOGOUT_EVENT = 'AUTH-LOGOUT-EVENT-v1';
const GET_CART_EVENT = 'GET-CART-SUCCESS-v1';
const ADD_TO_CART_EVENT = 'ADD-TO-CART-SUCCESS-v1';
const THEME_CLASSNAME_MAP = {
    zooplus: 'z-brand-theme-2024-zooplus',
    bitiba: 'z-brand-theme-2024-bitiba',
};

export { ADD_TO_CART_EVENT, AUTH_FAILURE_EVENT, AUTH_LOGOUT_EVENT, AUTH_READY, AUTH_SUCCESS_EVENT, BURGER_PANEL_PORTAL, GET_CART_EVENT, SECURITY_ICONS_ID, SHIPPING_FEE_TEXT_ID, THEME_CLASSNAME_MAP };
//# sourceMappingURL=constants.js.map
